"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.use = exports.Mixin = exports.mixin = void 0;
const mix_1 = require("./mix");
const utilities_1 = require("@rxap/utilities");
const reflect_metadata_1 = require("@rxap/reflect-metadata");
/**
 * @deprecated use @Mixin instead
 */
function mixin(...mixins) {
    return function (target) {
        (0, mix_1.mix)(target, mixins.reverse());
    };
}
exports.mixin = mixin;
function CopyMetadata(source, target) {
    const keys = (0, reflect_metadata_1.getMetadataKeys)(source);
    if (keys.length) {
        for (const key of keys) {
            const sourceMetadata = (0, reflect_metadata_1.getMetadata)(key, source);
            if (!(0, reflect_metadata_1.hasMetadata)(key, target)) {
                (0, reflect_metadata_1.setMetadata)(key, sourceMetadata, target);
            }
            else {
                const targetMetadata = (0, reflect_metadata_1.getMetadata)(key, target);
                if (Array.isArray(targetMetadata) && Array.isArray(sourceMetadata)) {
                    (0, reflect_metadata_1.setMetadata)(key, [...targetMetadata, ...sourceMetadata], target);
                }
                else {
                    const mergedMetadata = (0, utilities_1.deepMerge)(targetMetadata, sourceMetadata);
                    (0, reflect_metadata_1.setMetadata)(key, mergedMetadata, target);
                }
            }
        }
    }
}
function Mixin(...mixins) {
    return function (target) {
        (0, mix_1.mix)(target, mixins.reverse());
        for (const source of mixins.reverse()) {
            CopyMetadata(source, target);
            if (typeof source === 'function') {
                CopyMetadata(source.prototype, target.prototype);
            }
        }
    };
}
exports.Mixin = Mixin;
/**
 * @deprecated use @mixin instead
 */
function use(...mixins) {
    return function (target) {
        (0, mix_1.mix)(target.constructor, mixins.reverse());
    };
}
exports.use = use;
